export default {"src":"/_next/static/media/statsNotAvailable.eb7a3888.svg","height":98,"width":98,"blurWidth":0,"blurHeight":0};